<template>
  <div class="dialog-root">
    <div class="container">
      <avue-form ref="formRef" :option="formOption" v-model="formData">
        <template slot="basicInforId">
          <div class="select-append">
            <el-select
              v-model="formData.basicInforId"
              filterable
              placeholder="请选择 老人"
              :disabled="dialogType == 'view'"
            >
              <el-option
                v-for="item in elderList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button :disabled="dialogType == 'view'" icon="el-icon-plus" @click="showDialog">
            </el-button>
          </div>
        </template>
        <template slot="domicileAddressId">
          <avue-cascader
            placeholder="请选择住址"
            style="width: 100%; height: 32px"
            v-model="formData.domicileAddressId"
            :props="regionProps"
            lazy
            :lazy-load="lazyLoad"
            :disabled="dialogType == 'view'"
          ></avue-cascader>
        </template>
        <template slot="modifierAmount">
          <moneyInput
            style="width: 100%"
            v-model="formData.modifierAmount"
            :disabled="dialogType == 'view'"
          />
        </template>
        <template slot="projectAttachList">
          <VUpload
            :disabled="dialogType == 'view'"
            :limit="1"
            :fileList.sync="formData.projectAttachList"
          ></VUpload>
        </template>
        <template slot="pictureAttachList">
          <VUpload
            :disabled="dialogType == 'view'"
            :limit="10"
            :fileList.sync="formData.pictureAttachList"
          ></VUpload>
        </template>
      </avue-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn" v-if="dialogType != 'view'">
      <el-button type="primary" size="small" @click="doSave">
        {{ dialogType == 'add' ? '保存' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
    <hr-dialog
      v-if="isDialogShow"
      title="新增"
      :allowFull="false"
      width="80%"
      :visible.sync="isDialogShow"
    >
      <template slot="body">
        <peopleForm
          v-if="isDialogShow"
          model="add"
          :nursinghomeId="nursinghomeId"
          :row="{
            nursinghomeId: nursinghomeId,
          }"
          @cancle="isDialogShow = false"
          @success="addPeopleCb"
        ></peopleForm>
      </template>
    </hr-dialog>
  </div>
</template>

<script>
import VUpload from '@/views/components/v-upload';
import peopleForm from './peopleForm.vue';
import { removeStore } from '@/util/store';
import { getElderListApi, getDetailApi, addApi, updateApi } from '../api/reform';
import { getAreaExtend } from '../api/nursingManage.js';

export default {
  props: ['dialogType', 'rowData', 'nursinghomeId'],
  components: { VUpload, peopleForm },
  data() {
    return {
      elderList: [],
      currEelder: {},
      regionProps: {
        label: 'title',
        value: 'id',
      },
      isDialogShow: false,
      formData: {},
      formOption: {
        menuBtn: false,
        group: [
          {
            label: '基本信息',
            labelWidth: 160,
            column: [
              {
                label: '老人姓名',
                prop: 'basicInforId',
                span: 8,
                formslot: true,
                rules: [{ required: true, message: '请选择老人姓名', trigger: 'change' }],
              },
              {
                label: '老人身份证号',
                prop: 'certNo',
                span: 8,
                disabled: true,
              },
              {
                label: '联系电话',
                prop: 'tel',
                span: 8,
                maxlength: 11,
                showWordLimit: true,
                disabled: this.dialogType == 'view',
                rules: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
              },
              {
                label: '申请改造家庭住址',
                prop: 'domicileAddressId',
                span: 12,
                formslot: true,
                rules: [{ required: true, message: '请选择地址', trigger: 'blur' }],
              },
              {
                label: '',
                prop: 'address',
                span: 12,
                labelWidth: 0,
                maxlength: 200,
                showWordLimit: true,
                placeholder: '请输入详细地址',
                disabled: this.dialogType == 'view',
                rules: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
              },
              {
                label: '是否签订',
                prop: 'isSign',
                span: 8,
                type: 'radio',
                dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '签订业主与老人关系',
                prop: 'relationship',
                span: 8,
                display: true,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_relationship',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
                rules: [{ required: true, message: '请选择关系', trigger: 'change' }],
              },
              {
                label: '签订业主姓名',
                prop: 'personName',
                span: 8,
                maxlength: 20,
                showWordLimit: true,
                display: true,
                disabled: this.dialogType == 'view',
                rules: [{ required: true, message: '请输入签订业主姓名', trigger: 'blur' }],
              },
              {
                label: '签订日期',
                prop: 'signTime',
                span: 8,
                type: 'date',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                disabled: this.dialogType == 'view',
                rules: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
              },
              {
                label: ' 改造商',
                prop: 'modifier',
                span: 8,
                maxlength: 50,
                showWordLimit: true,
                disabled: this.dialogType == 'view',
              },
              {
                label: '改造负责人',
                prop: 'modifierName',
                span: 8,
                maxlength: 20,
                showWordLimit: true,
                disabled: this.dialogType == 'view',
              },
              {
                label: '改造金额(元)',
                prop: 'modifierAmount',
                span: 8,
                formslot: true,
              },
              {
                label: '合同状态',
                prop: 'contractStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_contract_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '排期',
                prop: 'scheduleTime',
                span: 8,
                type: 'date',
                format: 'yyyy-MM-dd',
                disabled: this.dialogType == 'view',
              },
              {
                label: '缴费状态',
                prop: 'paymentStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_payment_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '资料状态',
                prop: 'dataStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_data_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '扫描状态',
                prop: 'scanningStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_scanning_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '公示状态',
                prop: 'publicStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_public_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: this.dialogType == 'view',
              },
              {
                label: '档案状态',
                prop: 'fileStatus',
                span: 8,
                type: 'select',
                dicUrl: '/api/blade-system/dict/dictionary?code=elderly_file_status',
                props: {
                  label: 'dictValue',
                  value: 'dictKey',
                },
                disabled: true,
              },
              {
                label: '缺少资料',
                prop: 'lackInfo',
                span: 24,
                maxlength: 200,
                showWordLimit: true,
                disabled: this.dialogType == 'view',
              },
              {
                label: '备注',
                prop: 'remark',
                span: 24,
                type: 'textarea',
                minRows: 2,
                maxRows: 3,
                maxlength: 500,
                showWordLimit: true,
                disabled: this.dialogType == 'view',
              },
            ],
          },
          {
            label: '改造项目',
            labelWidth: 0,
            column: [
              {
                label: '',
                prop: 'projectAttachList',
                formslot: true,
              },
            ],
          },
          {
            label: '资料图片',
            labelWidth: 0,
            column: [
              {
                label: '',
                prop: 'pictureAttachList',
                formslot: true,
              },
            ],
          },
        ],
      },
    };
  },
  watch: {
    'formData.basicInforId'() {
      if (this.formData.basicInforId) {
        this.currEelder = this.elderList.find((item) => item.id == this.formData.basicInforId);
        if (this.currEelder) {
          this.formData.certNo = this.currEelder.idNumber;
          this.formData.tel = this.currEelder.tel;
        }
      }
    },
    'formData.isSign'(newVal) {
      const item = this.findObject(this.formOption.group[0].column, 'relationship');
      const item2 = this.findObject(this.formOption.group[0].column, 'personName');
      const item3 = this.findObject(this.formOption.group[0].column, 'signTime');
      if (newVal == '1') {
        item.display = false;
        item2.display = false;
        item3.display = false;
        this.formData.relationship = '';
        this.formData.personName = '';
        this.formData.signTime = '';
      } else if (newVal == '2') {
        item.display = true;
        item2.display = true;
        item3.display = true;
      }
      if (this.dialogType == 'add') {
        this.formData.fileStatus = newVal == '2' ? '2' : '1';
      }
    },
    'formData.relationship'(newVal, oldVal) {
      if (newVal == '1') {
        this.formData.personName = this.currEelder.name;
      } else if (oldVal) {
        this.formData.personName = '';
      }
    },
  },
  async created() {
    await this.getElderList();
    if (this.dialogType != 'add') {
      getDetailApi({
        id: this.rowData.id,
      }).then(({ data }) => {
        data.domicileAddressId =
          data.domicileAddressId == '' ? [] : data.domicileAddressId.split(',');
        this.formData = data;
      });
    } else {
      this.formData = {
        nursinghomeId: this.nursinghomeId,
        modifierAmount: '',
        isSign: '2',
        signTime: this.dayjs().format('YYYY-MM-DD'),
        contractStatus: '1',
        paymentStatus: '1',
        dataStatus: '1',
        scanningStatus: '1',
        publicStatus: '1',
        projectAttachList: [],
        pictureAttachList: [],
      };
    }
  },
  methods: {
    async getElderList() {
      await getElderListApi({
        nursinghomeId: this.nursinghomeId,
      }).then(({ data }) => {
        this.elderList = data || [];
      });
    },
    showDialog() {
      removeStore({
        name: 'elderId',
      });
      this.isDialogShow = true;
    },
    addPeopleCb() {
      this.isDialogShow = false;
      this.getElderList();
    },
    /* 懒加载地址 */
    lazyLoad(node, resolve) {
      let stop_level = 4;
      let level = node.level;
      let list = [];
      let callback = () => {
        resolve(
          (list || []).map((ele) => {
            return Object.assign(ele, {
              leaf: level >= stop_level,
            });
          })
        );
      };
      if (level == 0) {
        getAreaExtend().then((res) => {
          list = res.data;
          callback();
        });
      } else {
        getAreaExtend({ parentId: node.data.id }).then((res) => {
          list = res.data;
          callback();
        });
      }
    },
    /* 保存 */
    doSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$refs.formRef.allDisabled = false; // avue-form表单验证后会导致表单项禁止编辑，需要重置此属性解除这个限制
          let fn = this.dialogType == 'add' ? addApi : updateApi;
          const params = { ...this.formData };
          params.domicileAddressId =
            params.domicileAddressId && params.domicileAddressId.length > 0
              ? params.domicileAddressId.join(',')
              : '';
          fn(params, {
            showLoading: { text: '处理中...' },
          }).then(() => {
            this.$message.success('操作成功!');
            this.$emit('update');
          });
        }
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}
.select-append {
  width: 100%;
  display: flex;
  align-items: center;
  :nth-child(1) {
    flex: 1;
  }
}
</style>
